import OurStory from "./partials/OurStory";
import SectionHeader from "../include/SectionHeader";
import VissionMission from "./partials/VissionMission";
import AboutSection from "../home/partials/AboutSection";
import WhyLifeline from "./partials/WhyLifeline";
import Management from "./partials/Management";

const Aboutus = () => {
    return (
        <>
        <div className="about_component_wrapper">
            <section className="progress-section theme_content_section py-5">
                <div className="container">
                    <SectionHeader title={"Our Story"} />
                    <OurStory />
                </div>
            </section>
            <div className="container mt-4">
                <SectionHeader title={"The Founder"} />
            </div>
            <AboutSection />
            <VissionMission />
            <WhyLifeline />
            <Management />
        </div>
        </>
    );
};

export default Aboutus;